import React from "react";
import { 
  Calendar, 
  CheckCircle2, 
  ArrowRight, 
  Zap, 
  ShieldCheck, 
  MessageSquare, 
  Globe,
  Sparkles,
  Check
} from "lucide-react";
import { Card, CardContent } from "./ui/card";
import SagentLogo from "./SagentLogo";

// Brand Logo SVG Components
const AirbnbLogo = () => (
  <svg viewBox="0 0 32 32" className="w-5 h-5 fill-rose-500 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 1c2.008 0 3.463.963 4.751 3.269l.533.982C22.753 7.842 24.316 11.233 26 15c1.464 3.276 2.637 6.037 3 8-.565 3.053-.357 5.753-2.5 7.5-1.921 1.567-4.492 1.83-7.5 1.5-3.008-.33-5.5-1.5-7-3.5-1.5 2-3.992 3.17-7 3.5-3.008.33-5.579.067-7.5-1.5C3.357 28.753 2.435 26.053 3 23c.363-1.963 1.536-4.724 3-8 1.684-3.767 3.247-7.158 4.717-10.749l.533-.982C12.537 1.963 13.992 1 16 1zm0 3c-1.092 0-1.859.513-2.684 1.983l-.527.971C11.365 9.479 9.842 12.793 8.2 16.5c-1.391 3.111-2.492 5.706-2.8 7.375-.382 2.062.115 3.738 1.484 4.812 1.157.908 2.67.976 4.616.638 2.008-.348 3.847-1.42 5-3.325l.5-.838.5.838c1.153 1.905 2.992 2.977 5 3.325 1.946.338 3.459.27 4.616-.638 1.369-1.074 1.866-2.75 1.484-4.812-.308-1.669-1.409-4.264-2.8-7.375-1.642-3.707-3.165-7.021-4.589-10.546l-.527-.971C17.859 4.513 17.092 4 16 4zm0 10c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zm0 2c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"/>
  </svg>
);

const BookingLogo = () => (
  <svg viewBox="0 0 32 32" className="w-5 h-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="6" fill="#003580" />
    <text x="16" y="22" fill="#ffffff" fontSize="16" fontWeight="bold" fontFamily="system-ui, sans-serif" textAnchor="middle">B.</text>
  </svg>
);

const MMTLogo = () => (
  <svg viewBox="635 0 500 496" className="w-5 h-5 flex-shrink-0 animate-pulse" xmlns="http://www.w3.org/2000/svg">
    <path fill="#e31e25" d="m1023.5 495.8c30-0.4 58.4-12.1 79-33.1 21-21 32.7-49.4 32.7-79v-270.6c0-30-11.7-58.4-32.3-79.8-21-21-49.4-33.1-79.4-33.1h-271.9c-30 0.4-58.4 12.1-79 33.1-21 21.4-32.7 49.8-32.7 79.8v271c0.4 61.5 50.2 111.3 111.7 111.7"/>
    <path fill="#ffffff" d="m946.5 263.4c-10.5 35 6.6 70.1 42.8 56-10.5 25.3-28 63.1-28 102.4 0 0 0 26.5 19.4 33.1 0 0 27.2 6.6 21.4-17.5-4.3-15.2-5.4-30.7-3.5-46.3 6.6-32.3 16.7-63.9 30-94.2 0 0 41.6-86.9 65.7-127.3 0 0 10.1-20.7-10.5-20.7-6.2 0-12.1 3.1-15.9 8.2l-58.8 104.7c-8.9 16.4-17.5 21.4-24.1 21.4-14.8 0-11.7-23.7-9.3-32.3 6.6-29.2 17.1-57.2 31.1-84.1 10.5-22.9-10.5-24.9-10.5-24.9-13.3-3.5-23.4 18.3-23.4 18.3l-23.3 47.5c-15.2 26.5-31.9 51.8-49.8 76.3 0 0-3.1 3.9-5.5 2.4-2.3-2-1.1-5.9-1.1-5.9 3.9-32.3 10.5-64.2 19.4-95.8 0.4-1.9 0.8-3.5 0.8-5.4 0.4-4.3-0.8-8.6-3.5-11.7-2.7-3.5-6.6-5.4-10.9-5.4-10.5-1.2-15.5 3.8-24.9 15.1-20.6 25.3-44.7 63.5-56.4 80.6-1.2 2-3.5 1.6-3.5-1.1 0-7.8 27.2-91.9 27.2-91.9 0 0 3.2-11.7-6.2-15.6 0 0-14.4-8.9-26 8.6l-56.1 76.3c-4.2 5.8-6.6 3.9-6.6 3.9v-5.1l9-49.8c7-38.2-6.3-40.1-14.8-41.7-6.2 0-12.9 2-18.3 5.5-17.5 8.5-30.7 43.2-30.7 43.2 0 0-3.9 12.4 4.6 17.5 2.8 1.6 5.9 2.7 9 2.3 12.4-0.7 14.8-23.7 23.7-23.7 1.6 0 1.6 1.9 1.6 2.3l-28.8 121.1c-2 7 1.1 14.4 7 18.3 3.9 2.3 8.2 2.7 12.4 2 3.9-1.2 7.4-3.9 9.8-7.4l10.5-16.4c15.1-26.9 43.1-65.4 45.9-65.4 1.1 0 1.5 0 1.5 1.2l-10.5 71.2c-1.1 6.2 2.4 12.9 8.2 15.6 5.4 1.9 11.3 1.5 16.3-1.2 5.9-4.7 10.9-10.5 14.4-17.1 5.9-9.4 33.9-42.4 51-72.8 1.2-2 2.3 0 1.9 1.2-3.5 15.9-6.2 58.4-6.6 68.9-0.8 20.6 15.2 22.9 15.6 22.9 10.5 0.8 20.6-3.9 26.4-12.4"/>
  </svg>
);

const AgodaLogo = () => (
  <svg viewBox="0 50 140 22" className="w-10 h-3 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FCB716" d="M40.8395924,50.3726635 C35.1321043,50.3726635 30.4888815,55.0152227 30.4888815,60.7227109 C30.4888815,66.4295355 35.1321043,71.0727583 40.8395924,71.0727583 C46.5470806,71.0727583 51.1896398,66.4295355 51.1896398,60.7227109 C51.1896398,55.0152227 46.5470806,50.3726635 40.8395924,50.3726635"/>
    <path fill="#EE363F" d="M11.9155261,50.3726635 C6.20803791,50.3726635 1.56547867,55.0152227 1.56547867,60.7227109 C1.56547867,66.4295355 6.20803791,71.0727583 11.9155261,71.0727583 C17.6223507,71.0727583 22.266237,66.4295355 22.266237,60.7227109 C22.266237,55.0152227 17.6223507,50.3726635 11.9155261,50.3726635"/>
    <path fill="#07AF56" d="M69.7637251,50.3726635 C64.0555735,50.3726635 59.4130142,55.0152227 59.4130142,60.7227109 C59.4130142,66.4295355 64.0555735,71.0727583 69.7637251,71.0727583 C75.4705498,71.0727583 80.1137725,66.4295355 80.1137725,60.7227109 C80.1137725,55.0152227 75.4705498,50.3726635 69.7637251,50.3726635"/>
    <path fill="#04A9DF" d="M127.61,50.3726635 C121.902512,50.3726635 117.259953,55.0152227 117.259953,60.7227109 C117.259953,66.4295355 121.902512,71.0727583 127.61,71.0727583 C133.317488,71.0727583 137.960047,66.4295355 137.960047,60.7227109 C137.960047,55.0152227 133.317488,50.3726635 127.61,50.3726635"/>
    <path fill="#A1479A" d="M98.6871943,50.373327 C92.9797062,50.373327 88.3358199,55.0158863 88.3358199,60.7227109 C88.3358199,66.4301991 92.9790427,71.0720948 98.6865308,71.0720948 C104.394019,71.0720948 109.036578,66.4301991 109.036578,60.7227109 C109.036578,55.0158863 104.394682,50.373327 98.6871943,50.373327"/>
  </svg>
);

const WhatsAppLogo = () => (
  <svg viewBox="0 0 175.216 175.552" className="w-5 h-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
    <path fill="#25D366" d="M90.914 172.977c-15.034 0-29.774-3.935-42.627-11.379l-3.056-1.815-31.7 8.311 8.455-30.908-1.99-3.167C12.35 120.916 8.35 106.183 8.356 90.914c.018-45.526 37.04-82.548 82.58-82.548 22.062.01 42.8 8.604 58.397 24.214s24.18 36.35 24.17 58.416c-.02 45.53-37.05 82.553-82.59 82.553"/>
    <path fill="#FFF" d="M12.966 161.238l10.439-38.114a73.42 73.42 0 0 1-9.821-36.772C13.601 45.83 46.611 12.83 87.168 12.83c19.681.01 38.154 7.669 52.047 21.572s21.537 32.383 21.53 52.037c-.018 40.553-33.027 73.553-73.578 73.553h-.032a73.23 73.23 0 0 1-35.159-8.954l-39.01 10.2zm38.11-23.54l2.235 1.32c11.97 7.11 25.7 10.86 39.78 10.87h.03c33.707 0 61.139-27.426 61.153-61.135.006-16.335-6.349-31.696-17.895-43.251A60.75 60.75 0 0 0 87.94 25.983c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.312-6.179 22.558 39.53-10.232z"/>
    <path fill="#FFF" d="M123.6 100.916c-1.852-.927-10.95-5.405-12.645-6.023-1.696-.618-2.93-.927-4.165.927-1.235 1.854-4.786 6.023-5.867 7.258-1.08 1.236-2.16 1.39-4.013.463-1.852-.926-7.818-2.883-14.89-9.19-5.503-4.908-9.218-10.97-10.298-12.825-1.08-1.854-.116-2.856.81-3.778.834-.83 1.853-2.162 2.78-3.243.926-1.08 1.235-1.854 1.852-3.089.617-1.235.308-2.316-.154-3.243-.463-.927-4.165-10.033-5.708-13.737-1.503-3.61-3.15-3.12-4.316-3.18-1.119-.057-2.4-.067-3.68-.067-1.282 0-3.36.48-5.118 2.4-1.758 1.92-6.723 6.57-6.723 16.015 0 9.444 6.87 18.575 7.827 19.866.957 1.291 13.52 20.641 32.748 28.948 4.575 1.977 8.147 3.16 10.932 4.047 4.595 1.457 8.778 1.252 12.09 1.157 3.69-.105 10.95-4.477 12.492-8.58 1.543-4.102 1.543-7.618 1.08-8.58-.463-.962-1.728-1.512-3.58-2.438z"/>
  </svg>
);

const InstagramLogo = () => (
  <svg viewBox="0 0 32 32" className="w-5 h-5 fill-none stroke-[2.5] flex-shrink-0" stroke="#E1306C" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="26" height="26" rx="7" />
    <circle cx="16" cy="16" r="6" />
    <circle cx="23" cy="9" r="1.5" fill="#E1306C" />
  </svg>
);

const DirectLogo = () => (
  <svg viewBox="0 0 32 32" className="w-5 h-5 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="12" />
    <path d="M2 16h28" />
    <path d="M16 2a15.3 15.3 0 0 1 4 14 15.3 15.3 0 0 1-4 14 15.3 15.3 0 0 1-4-14 15.3 15.3 0 0 1 4-14z" />
  </svg>
);

const GoibiboLogo = () => (
  <svg viewBox="0 0 32 32" className="w-5 h-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="14" fill="#FF5A00" />
    <text x="16" y="21" fill="#ffffff" fontSize="13" fontWeight="900" fontFamily="system-ui, -apple-system, sans-serif" textAnchor="middle">go</text>
  </svg>
);

export const CalendarSync = () => {
  const channels = [
    { name: "Airbnb", logo: <AirbnbLogo />, status: "Connected", x: 50, y: 8, midpoint: { x: 50, y: 28 }, posClass: "top-[2%] left-1/2 -translate-x-1/2" },
    { name: "MakeMyTrip", logo: <MMTLogo />, status: "Connected", x: 80, y: 22, midpoint: { x: 65, y: 36 }, posClass: "top-[16%] right-[8%] xl:right-[12%]" },
    { name: "Goibibo", logo: <GoibiboLogo />, status: "Connected", x: 90, y: 50, midpoint: { x: 70, y: 50 }, posClass: "top-1/2 -translate-y-1/2 right-[1%] xl:right-[4%]" },
    { name: "Instagram Agent", logo: <InstagramLogo />, status: "Connected", x: 80, y: 78, midpoint: { x: 65, y: 64 }, posClass: "bottom-[16%] right-[8%] xl:right-[12%]" },
    { name: "Direct Booking", logo: <DirectLogo />, status: "Connected", x: 50, y: 92, midpoint: { x: 50, y: 71 }, posClass: "bottom-[2%] left-1/2 -translate-x-1/2" },
    { name: "WhatsApp Agent", logo: <WhatsAppLogo />, status: "Connected", x: 20, y: 78, midpoint: { x: 35, y: 64 }, posClass: "bottom-[16%] left-[8%] xl:left-[12%]" },
    { name: "Agoda", logo: <AgodaLogo />, status: "Connected", x: 10, y: 50, midpoint: { x: 30, y: 50 }, posClass: "top-1/2 -translate-y-1/2 left-[1%] xl:left-[4%]" },
    { name: "Booking.com", logo: <BookingLogo />, status: "Connected", x: 20, y: 22, midpoint: { x: 35, y: 36 }, posClass: "top-[16%] left-[8%] xl:left-[12%]" }
  ];

  const stats = [
    { label: "Connected Channels", value: "17", icon: Calendar, color: "text-blue-500", bg: "bg-blue-50" },
    { label: "Sync Accuracy", value: "100%", icon: ShieldCheck, color: "text-emerald-500", bg: "bg-emerald-50" },
    { label: "Avg. Sync Time", value: "2.3s", icon: Zap, color: "text-purple-500", bg: "bg-purple-50" },
    { label: "Double Bookings", value: "0", icon: ShieldCheck, color: "text-amber-500", bg: "bg-amber-50" }
  ];

  return (
    <section id="calendar-sync" className="py-24 md:py-32 bg-slate-50 relative overflow-hidden" data-testid="calendar-sync-section">
      <div className="absolute inset-0 bg-grid opacity-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Header */}
        <div className="mb-16 text-center space-y-4">
          <h2 className="text-3xl sm:text-5xl font-extrabold text-slate-900 font-['Lexend'] tracking-tight leading-[1.15]">
            One Booking. <span className="text-cyan-600">Every Channel</span> Updated Instantly.
          </h2>
          <p className="text-base sm:text-lg text-slate-500 max-w-2xl mx-auto leading-relaxed font-medium">
            Sagent connects with all your booking channels and updates availability in real-time to prevent double bookings.
          </p>
        </div>

        {/* Radial Layout Visualization Container */}
        <div className="relative w-full overflow-hidden flex items-center justify-center h-[280px] sm:h-[450px] md:h-[520px] lg:h-[620px] mb-8 sm:mb-16">
          
          {/* Scaled Wrapper */}
          <div className="w-[850px] h-[600px] shrink-0 scale-[0.42] sm:scale-[0.7] md:scale-[0.85] lg:scale-100 origin-center transition-transform duration-300 relative">
            
            {/* Concentric dotted orbit lines in background */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[340px] h-[340px] sm:w-[420px] sm:h-[420px] border border-dashed border-cyan-500/10 rounded-full pointer-events-none animate-[spin_120s_linear_infinite]" />
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[220px] sm:w-[280px] sm:h-[280px] border border-dashed border-cyan-500/15 rounded-full pointer-events-none animate-[spin_80s_linear_infinite]" />

            {/* SVG Connector Lines */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" xmlns="http://www.w3.org/2000/svg">
              {channels.map((channel, i) => (
                <line 
                  key={i}
                  x1="50%" 
                  y1="50%" 
                  x2={`${channel.x}%`} 
                  y2={`${channel.y}%`} 
                  stroke="#06b6d4" 
                  strokeWidth="1.5" 
                  strokeDasharray="4 4"
                  className="opacity-40 animate-[dash_10s_linear_infinite]"
                />
              ))}
            </svg>

            {/* Central Sagent Circle */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 flex flex-col items-center justify-center">
              {/* Pulsing ring outer container */}
              <div className="relative w-40 h-40 sm:w-48 sm:h-48 rounded-full bg-white shadow-xl shadow-cyan-500/10 border border-cyan-100 flex items-center justify-center p-3">
                <div className="absolute -inset-1.5 rounded-full border border-cyan-500/20 animate-ping opacity-75" style={{ animationDuration: '3s' }} />
                <div className="w-full h-full rounded-full bg-gradient-to-tr from-cyan-50 to-blue-50/20 border border-cyan-100 flex flex-col items-center justify-center p-4 text-center">
                  <SagentLogo className="w-10 h-10 text-cyan-600 mb-2 drop-shadow-sm animate-pulse" />
                  <span className="text-xs sm:text-sm font-bold text-slate-800 tracking-wider">SAGENT AI</span>
                  <div className="flex items-center gap-1.5 mt-1 bg-cyan-600/5 px-2.5 py-0.5 rounded-full border border-cyan-500/10">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                    <span className="text-[9px] font-bold text-cyan-700 uppercase tracking-widest">Always in sync</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Connected Indicators (Green checks on vectors) */}
            {channels.map((channel, i) => (
              <div 
                key={i} 
                className="absolute z-20 -translate-x-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-green-500 border-2 border-white shadow-md flex items-center justify-center pointer-events-none hover:scale-110 transition-transform"
                style={{ left: `${channel.midpoint.x}%`, top: `${channel.midpoint.y}%` }}
              >
                <Check className="w-3.5 h-3.5 text-white stroke-[3.5]" />
              </div>
            ))}

            {/* Channel Cards */}
            {channels.map((channel, i) => (
              <div 
                key={i} 
                className={`absolute z-10 w-44 bg-white rounded-2xl p-3 sm:p-4 border border-black/5 shadow-md shadow-slate-100 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 ${channel.posClass}`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center flex-shrink-0">
                    {channel.logo}
                  </div>
                  <div className="min-w-0">
                    <h4 className="text-xs sm:text-sm font-semibold text-slate-800 leading-tight">{channel.name}</h4>
                    <span className="text-[9px] font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full mt-0.5 inline-block">
                      {channel.status}
                    </span>
                  </div>
                </div>
              </div>
            ))}

          </div>

        </div>

        {/* Stats Row */}
        <div className="w-full max-w-5xl mx-auto bg-white rounded-3xl p-6 sm:p-8 border border-black/5 shadow-lg shadow-slate-100/50">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-slate-100">
            {stats.map((stat, i) => (
              <div key={i} className={`flex items-center gap-4 ${i >= 2 ? 'pt-6 md:pt-0' : ''} ${i % 2 !== 0 ? 'pl-4 md:pl-6' : 'md:pl-6'} ${i === 0 ? 'md:pl-0' : ''}`}>
                <div className={`w-12 h-12 rounded-2xl ${stat.bg} flex items-center justify-center flex-shrink-0`}>
                  <stat.icon className={`w-5 h-5 ${stat.color}`} />
                </div>
                <div className="min-w-0">
                  <p className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-['Lexend'] tracking-tight leading-none">
                    {stat.value}
                  </p>
                  <p className="text-[10px] sm:text-xs text-slate-400 font-bold uppercase tracking-wider mt-1.5">
                    {stat.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default CalendarSync;
